/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from "@theme-ui/mdx"
import { connect } from "react-redux"

import Button from "@components/Button"
import ButtonLink from "@components/ButtonLink"
import { rem } from "@src/theme"
import Spacer from "@components/Spacers"

const DonateCard = ({ amount, text, openDonationModal }) => (
  <div
    sx={{
      px: [2, 4],
      py: [rem(24), rem(36)],
      bg: "white",
    }}
  >
    <div
      sx={{
        width: "90%",
        m: "0 auto",
        textAlign: "center",
        color: "darkPurple",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      <Themed.h2
        sx={{
          m: 0,
          pt: 6,
          pb: 1

        }}
      >
        ${amount}
      </Themed.h2>
      <Spacer.XSmall />
      <p sx={{ variant: "typography.sizing.bodyCopyLarge", m: 0 }}>{text}</p>
      <Spacer.Small />
    </div>
  </div>
)

export default connect(null, dispatch => ({
  openDonationModal: () => dispatch.donationModal.toggleDonationModal(true),
}))(DonateCard)
